const CHROME_KIOSK_MODE_DETECTED = 'CHROME_KIOSK_MODE_DETECTED'
const USER_UPDATED = 'USER_UPDATED'
const LICENSE_UPDATED = 'LICENSE_UPDATED'
const LICENSE_LOADED = 'LICENSE_LOADED'

const state = {
  chromeKioskModeDetected: false,
  user: undefined,
  license: undefined,
  licenseLoaded: false
}

// Mutations
const mutations = {
  [CHROME_KIOSK_MODE_DETECTED] (state, payload) {
    state.chromeKioskModeDetected = payload
  },
  [USER_UPDATED] (state, payload) {
    state.user = Object.assign({}, state.user, payload)
  },
  [LICENSE_UPDATED] (state, payload) {
    state.license = Object.assign({}, state.license, payload)
  },
  [LICENSE_LOADED] (state) {
    state.licenseLoaded = true
  }
}

/**
 * GETTERS
 */
const getters = {
  isLicenseValid: state => {
    return (state.license && state.license.validTo && state.license.validTo > new Date())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
